// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1ohRe","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1uMB3"};